<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full xl:w-1/3 lg:w-1/2 md:w-1/2" >
                <vx-card :title="$t('Data')" class="mb-base" id="page-user-view" v-if="this.vehicle">
                    <table>
                        <tr>
                            <td class="font-semibold">{{$t("Name")}}</td>
                            <td>{{ this.vehicle.name }}</td>
                        </tr>
                        <tr>
                            <td class="font-semibold">{{$t("Registration")}}</td>
                            <td>{{ this.vehicle.registration }}</td>
                        </tr>
                    </table>

                    <vs-divider/>
                    <vs-button class="mt-5 mr-3" style="float: left" color="warning" icon-pack="feather" icon="icon-edit" type="border" @click="editVehiclePrompt = true" >{{$t("Edit")}}</vs-button>
                    <div style="clear: both"/>

                    <vs-popup :title="$t('Edit')" :active.sync="editVehiclePrompt">
                        <div>
                            <p class="mt-6">{{$t("Name")}}</p>
                            <vs-input v-model="editName" style="width: 100%"></vs-input>
                            <p class="mt-6">{{$t("Registration")}}</p>
                            <vs-input v-model="editRegistration" style="width: 100%"></vs-input>
                            <vs-divider/>
                            <vs-button style="float: left" color="success" icon-pack="feather" icon="icon-edit" type="border" class="mt-6; mr-1" @click="editVehicle">{{$t("Change")}}</vs-button>
                            <vs-button style="float: right" type="border" color="danger" icon-pack="feather" icon="icon-trash-2" @click="removeVehicle">{{$t("Delete")}}</vs-button>
                        </div>
                    </vs-popup>

                </vx-card>
            </div>
            <div class="vx-col w-full xl:w-2/3 lg:w-1/2 md:w-1/2">
                <periods-table :vehicle-id="Number(this.$route.params.id)"></periods-table>
            </div>
        </div>
    </div>
</template>
<script>
    import PeriodsTable from "./PeriodsTable";
    export default {
        components: {PeriodsTable},
        data() {
            return {

                vehicle: null,

                editVehiclePrompt: false,

                editName: '',
                editRegistration: '',
            }
        },
        methods: {
            updateVehicle() {
                const thisIns = this;
                this.$http.get('/api/artificial_transport/v1/vehicle/' + this.$route.params.id)
                    .then(function (response) {
                        thisIns.vehicle = response.data;
                        thisIns.editName = thisIns.vehicle.name;
                        thisIns.editRegistration = thisIns.vehicle.registration
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            editVehicle() {
                const thisIns = this;
                this.$http.put('/api/artificial_transport/v1/vehicle/' + this.$route.params.id, {
                    name: thisIns.editName,
                    registration: thisIns.editRegistration
                }).then(function () {
                    thisIns.updateVehicle();
                    thisIns.editVehiclePrompt = false;
                }).catch(function (error) {
                    thisIns.editVehiclePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
            removeVehicle() {
                const thisIns = this;
                this.$http.delete('/api/artificial_transport/v1/vehicle/' + this.$route.params.id)
                    .then(function () {
                        thisIns.editVehiclePrompt = false;
                        thisIns.$nextTick(() => {
                            thisIns.$router.push('/at_vehicles')
                        });
                }).catch(function (error) {
                    thisIns.editVehiclePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        },
        created() {
            this.updateVehicle()
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.editVehiclePrompt){
                this.editVehiclePrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }
</script>
